import { createContext, useContext } from 'react';
import { TreeBenhAnNode } from '../models/BenhAnModel';

export type BenhAnContextProps = {
  currentUser: any;
  phieuBenhAn: TreeBenhAnNode;
  setPhieuBenhAn: (data: TreeBenhAnNode) => void;
};

export const initialBenhAnContextValue: TreeBenhAnNode = {
  id:'',
  termId: 0,
  code: '',
  name: '',
  displayCode: '',
  filter: [],
  sortWeight: 0,
  attributes: {
    isMultiple: '',
    docTemplate: '',
  },
};

export const BenhAnContext = createContext<BenhAnContextProps>({
  currentUser: {},
  phieuBenhAn: initialBenhAnContextValue,
  setPhieuBenhAn: () => {},
});

export const useBenhAnContext = () => useContext(BenhAnContext);
